import { createFileRoute, useParams } from '@tanstack/react-router';

import { CurriculumTab } from '@/views/admin/courses/tabs/curriculum-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/curriculum')({
  component: CurriculumRoute,
});

function CurriculumRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/curriculum' });
  return <CurriculumTab id={id} />;
}
